export default function GlobalBackground({ children }) {
  return (
    <div className="relative min-h-screen bg-[#f7f5f2]">
      
      {/* SADECE ARKA PLAN */}
      <div
        className="fixed inset-0 -z-10"
        aria-hidden="true"
      />

      {/* SAYFA İÇERİĞİ */}
      {children}
    </div>
  )
}
